import { render, staticRenderFns } from "./listRoomDecorationRecordList.vue?vue&type=template&id=6bedc1d4&scoped=true"
import script from "./listRoomDecorationRecordList.vue?vue&type=script&lang=js"
export * from "./listRoomDecorationRecordList.vue?vue&type=script&lang=js"
import style0 from "./listRoomDecorationRecordList.vue?vue&type=style&index=0&id=6bedc1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bedc1d4",
  null
  
)

export default component.exports